import { configureStore } from '@reduxjs/toolkit'
import userTagsReducer from './slices/userTagsSlice'

export const store = configureStore({
    reducer: {
        userTags: userTagsReducer,
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
